import {push } from 'notivue';
import Swal from "sweetalert2";

export function notifyError(message) {
    push.error({
        title: 'Erro!',
        message,
        duration: 5000
    })
}

export function notifySuccess(message) {
    push.success({
        title: 'Sucesso!',
        message,
        duration: 5000
    })
}

export function getMessageError(data) {
    const keys = Object.keys(data);
    notifyError(data[keys[0]][0]);
}

export async function messageSwal(title, text, type) {
    return Swal.fire({
            title,
            text,
            icon: type,
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Confirmar",
        })
        .then((result) => {
            return !!result.value;

        })
        .catch(() => {
            return false;
        });
}
